<template>
  <section class="my-5">
    <h1>404 Not Found</h1>
    <p>
      指定されたURLは見つかりませんでした。
    </p>
    <p>
      <router-link to="/" class="link">イントロダクションへ</router-link>
      <router-link to="/app" class="link">アプリケーションへ</router-link>
    </p>
  </section>
</template>
<script>
export default {
  name: 'NotFoundComponent',
}
</script>
<style scoped>
.link{
  display: inline-block;
  margin: 2rem;
  padding: 0.5rem 2rem;
  text-align: center;
  border-radius: 2rem;
  border: 1px solid #999;
}
</style>